import { Button, Modal, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import CustomForm from "../CustomForm";
import { useParams } from "react-router-dom";
import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";
import {
  roles,
  statusPrestationsValues,
  subStatus,
} from "../../../utils/constants";
import { createPortal } from "react-dom";
import { modalsByContext } from "./modals";
import dayjs from "../../../utils/dayjs";
import {
  cancelPrestation,
  getPrestation,
  setPropertiesPrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { UserContext } from "../../../engine/context/User.context";
import { MdOutlineFreeCancellation } from "react-icons/md";
import { AiFillCalendar } from "react-icons/ai";
import { t } from "i18next";

export const PrestationCancel = ({ defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const { prestation, loading } = useSelector(state => state.prestation);
  const { status } = prestation;
  const { user } = useContext(UserContext);

  const inputs = inputsCancel({ prestation });

  const formRef = useRef(null);

  const context = useContext(ModalContext);
  const dispatch = useDispatch();

  const onSubmitForm = async data => {
    if (user.role === roles.institution) {
      data.cancel.cancelAt = dayjs().format();
      data.subStatus = subStatus.institution;
    }

    const updated = {
      status: statusPrestationsValues.cancel,
      subStatus: data.subStatus,
      cancel: {
        cancelNote: data.cancel.cancelNote,
        cancelAt:
          data.cancel.cancelAt === null
            ? dayjs().format()
            : data.cancel.cancelAt,
        cancelBy: user._id,
      },
    };

    await dispatch(setPropertiesPrestation(updated));
    await dispatch(cancelPrestation());

    await dispatch(getPrestation(prestation._id));

    close();
  };

  const close = () => {
    setOpen(false);
    context.closeModal(modalsByContext.PrestationCancel);
  };

  const config = {
    key: prestation._id + modalsByContext.PrestationCancel,
    containerStyle: { minWidth: "500px" },
    title: t("PrestationCancel.title"),
    open: open,
    cancelText: t("PrestationCancel.cancelText"),
    okText: t("PrestationCancel.okText"),
    onOk: () => {
      formRef.current.submit();
    },
    onCancel: close,
    content: (
      <>
        <p>{t("PrestationCancel.content1")}</p>

        {onlyRoleMapping([roles.institution]) && (
          <cite>{t("PrestationCancel.cite")}</cite>
        )}

        <CustomForm
          dataSource={inputs}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          onValuesChange={undefined}
        />
      </>
    ),
    footer: [
      <Button key="close" onClick={close} loading={loading}>
        {t("PrestationCancel.cancelText")}
      </Button>,
      <Button
        loading={loading}
        icon={<MdOutlineFreeCancellation size={20} />}
        type="primary"
        onClick={async () => {
          try {
            const test = await formRef.current.validateFields();
            formRef.current.submit();
          } catch (e) {
            notification.error({
              message:
                e.errorFields.length +
                t("PrestationCancel.common.fieldsRequired"),
            });
          }
        }}
      >
        {t("PrestationCancel.okText")}
      </Button>,
    ],
  };

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};

export const inputsCancel = ({ prestation, user }) => {
  const { cancel } = prestation;

  return [
    {
      parentLabel: "",
      children: [
        {
          label: t("PrestationCancel.subStatus.label"),
          required: true,
          name: "subStatus",
          type: "radios",
          value: prestation.subStatus,
          size: "small",
          visible: userHasLevel({
            only: {
              [roles.permanance]: "r",
              [roles.admin]: "r",
            },
          }),
          radios: [
            {
              label: t("PrestationCancel.subStatus.option1"),
              value: subStatus.institution,
            },
            {
              label: t("PrestationCancel.subStatus.option2"),
              value: subStatus.interprete,
              visible: onlyRoleMapping([roles.superAdmin]),
            },
            {
              label: t("PrestationCancel.subStatus.option3"),
              value: subStatus.permanance,
            },
            {
              label: t("PrestationCancel.subStatus.option4"),
              value: subStatus.duplicate,
              visible: onlyRoleMapping([roles.superAdmin]),
            },
          ],
          col: 24,
        },
        {
          label: t("PrestationCancel.cancelAt.label"),
          quote: t("PrestationCancel.cancelAt.quote"),
          name: "cancel.cancelAt",
          visible: userHasLevel({
            only: {
              [roles.permanance]: "r",
              [roles.admin]: "r",
            },
          }),
          value: cancel?.cancelAt ? dayjs(cancel.cancelAt) : null,
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          showClear: true,
          type: "date-time",
          col: 24,
        },
        {
          label: t("PrestationCancel.cancelNote.label"),
          required: true,
          name: "cancel.cancelNote",
          type: "textarea",
          value: cancel?.cancelNote || "",
          rows: 2,
          col: 24,
        },
      ],
    },
  ];
};
